import config from '../config';

export const isBmOrSnsOrDev =
  config.BASE_TENANT === 'BM' ||
  config.BASE_TENANT === 'SNS' ||
  config.BASE_TENANT === 'DEV';
